import { mapState, mapMutations } from "vuex";

import {
  STATUS_INITIALIZED,
  STATUS_DONE,
  STATUS_CANCELED
} from "@/domain/status.types";

export default {
  data() {
    return {
      statusDoneCallback: undefined,
      statusCanceledCallback: undefined
    };
  },
  computed: {
    ...mapState({
      status: state => state.textEditor.status,
      text: state => state.textEditor.text
    })
  },
  methods: {
    ...mapMutations([
      "clearTextEditorText",
      "setTextEditorText",
      "setTextEditorStatus",
      "setRequaredField",
      "setLinkList",
      "setImageList"
    ]),
    setText(val, requaredField) {
      this.clearTextEditorText();
      this.setTextEditorStatus(STATUS_INITIALIZED);
      this.setTextEditorText(val);
      this.setRequaredField(requaredField);
    },
    setLinkListForEditor(list) {
      this.setLinkList(list);
    },
    setImageListForEditor(list) {
      this.setImageList(list);
    },
    async checkStatus() {
      if ([STATUS_CANCELED, STATUS_DONE].includes(this.status)) {
        if (this.status === STATUS_DONE) {
          if (this.statusDoneCallback) {
            this.statusDoneCallback(this.text); // From main component
            this.statusDoneCallback = undefined;
          }
        } else {
          if (this.statusCanceledCallback) {
            this.statusCanceledCallback(); // From main component
            this.statusCanceledCallback = undefined;
          }
        }

        this.clearTextEditorText();
      }
    }
  },
  beforeDestroy() {
    this.clearTextEditorText();
  },
  watch: {
    status: function () {
      this.checkStatus();
    }
  }
};
